<svg #svg width="100%" height="100%">
  <g #g>
    <image #image />
    <polygon #polygon visibility="hidden" opacity="0.25" fill="gold" stroke="gold" />
  </g>
</svg>
